"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24458],{

/***/ 24458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_page_Price; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/features/home-page/Price/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 32px;\n      margin-bottom: 50px;\n\n      @media ",
        " {\n        font-size: 44px;\n        text-align: center;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 44px;\n  margin-bottom: 45px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 6.5vh;\n    margin-bottom: 15px;\n    text-align: left;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 17px;\n  margin: auto;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 19px;\n    margin: unset;\n    text-align: left;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  text-align: center;\n  width: 100%;\n\n  @media ",
        " {\n    font-size: 20px;\n    width: 100%;\n  }\n\n  b {\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  flex-direction: column;\n  margin: 0 auto;\n  margin-bottom: 100px;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n\n  & > .small,\n  & > .medium,\n  & > .regular,\n  & > .big {\n    width: 100%;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n\n    div:first-child {\n      padding-right: 50px;\n    }\n    div:last-child {\n      padding-left: 50px;\n    }\n\n    & > div.regular {\n      width: 60%;\n    }\n\n    & > div.big {\n      width: 70%;\n    }\n\n    & > div.medium {\n      width: 50%;\n    }\n\n    & > div.small {\n      width: 40%;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 50px;\n  margin-bottom: 20px;\n  width: 100%;\n\n  img {\n    height: 50px;\n\n    &.left {\n      float: left;\n      margin-top: -50px;\n    }\n\n    &.right {\n      float: right;\n      margin-bottom: -50px;\n    }\n  }\n\n  @media ",
        " {\n    img {\n      height: auto;\n    }\n  }\n\n  @media ",
        " {\n    img {\n      &.right {\n        margin-bottom: -75px;\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 40px;\n\n  @media ",
        " {\n    font-size: 60px;\n  }\n\n  @media ",
        " {\n    font-size: 80px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n\n  @media ",
        " {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n\n  @media ",
        " {\n    justify-content: flex-start;\n\n    img {\n      max-width: 100%;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function(props) {
    return {
        as: props.small ? "h2" : "h1",
        family: "bold",
        height: 1,
        m: 0
    };
}).withConfig({
    componentId: "sc-3ef4e1f8-0"
})(_templateObject1(), device/* default.laptop */.Z.laptop, function(props) {
    return(// @ts-expect-error
    props.small && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), device/* default.laptop */.Z.laptop));
});
var styled_Text = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    family: "light",
    height: 1.5
}).withConfig({
    componentId: "sc-3ef4e1f8-1"
})(_templateObject2(), device/* default.laptop */.Z.laptop);
var PriceDesc = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-3ef4e1f8-2"
})(_templateObject3(), device/* default.laptop */.Z.laptop);
var ContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3ef4e1f8-3"
})(_templateObject4(), device/* default.laptop */.Z.laptop);
var PriceWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-3ef4e1f8-4"
})(_templateObject5(), device/* default.tablet */.Z.tablet, device/* default.laptopL */.Z.laptopL);
var PriceRate = (0,styled_components_browser_esm/* default */.ZP)(styled_Text).attrs({
    family: "bold",
    color: color/* default.primary */.Z.primary
}).withConfig({
    componentId: "sc-3ef4e1f8-5"
})(_templateObject6(), device/* default.tablet */.Z.tablet, device/* default.laptopL */.Z.laptopL);
var PriceLabel = (0,styled_components_browser_esm/* default */.ZP)(styled_Text).withConfig({
    componentId: "sc-3ef4e1f8-6"
})(_templateObject7(), device/* default.laptop */.Z.laptop);
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3ef4e1f8-7"
})(_templateObject8(), device/* default.laptop */.Z.laptop);


// EXTERNAL MODULE: ./src/features/home-page/styled.ts
var styled = __webpack_require__(24529);
;// CONCATENATED MODULE: ./src/features/home-page/Price/index.tsx





function Price() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Wrapper */.im, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    direction: "column",
                    align: "center",
                    // @ts-expect-error
                    mx: "auto",
                    className: "big",
                    style: {
                        padding: 0,
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            small: true,
                            children: "Biaya Normal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/table-price-left.svg",
                                    alt: "sprinkle",
                                    className: "left"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLabel, {
                                            children: "Fee Beli"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceRate, {
                                            children: "0,15%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLabel, {
                                            children: "Fee Jual"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceRate, {
                                            children: "0,25%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/table-price-right.svg",
                                    alt: "sprinkle",
                                    className: "right"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceDesc, {
                            size: "20px",
                            align: "center",
                            padding: "15px 60px",
                            as: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Text, {
                                    size: "20px",
                                    family: "bold",
                                    as: "b",
                                    children: "Keterangan:"
                                }),
                                " ",
                                "Sudah termasuk biaya broker, biaya levy (BEI, KPEI, KSEI) 0,043%, PPN biaya",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "broker 10%, dan PPh final untuk transaksi jual 0,1%."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        className: "small",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/buy-sell-image.svg",
                            alt: "Bebas biaya broker"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        className: "medium",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "Daftar 100% Online Tanpa Minimum Deposit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Text, {
                                children: "Akun rekening kamu akan diproses secara digital tanpa perlu mengirim dokumen fisik."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var home_page_Price = (Price);


/***/ }),

/***/ 24529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NZ": function() { return /* binding */ SectionTitle; },
/* harmony export */   "Vq": function() { return /* binding */ SectionSubtitle; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var _keyframes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16681);
/* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    padding: 50px 0;\n    width: calc(100% - 150px);\n  }\n\n  // animations\n  .scaleUpX {\n    transform: scale(0.9);\n  }\n\n  .fadeInRightX,\n  .fromRightX,\n  .fadeInLeftlongX,\n  .fadeInLeftBorderX,\n  .fadeInLeftX2,\n  .fadeInLeftX,\n  .fadeInX,\n  .fadeInTopX,\n  .fadeInDownX,\n  .scaleUpX {\n    opacity: 0;\n  }\n\n  .fadeInLeftBorderX.on,\n  .fadeInLeftX.on,\n  .fadeInX.on {\n    opacity: 1;\n  }\n\n  .fadeIn {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fromRight {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInRight {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft2 {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    animation-delay: 0.3s;\n  }\n\n  .fadeInTopX {\n  }\n\n  .fadeInTop {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fadeInDown {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fromRightP:nth-child(1) .fromRight {\n    animation-delay: 0.2s;\n  }\n\n  .fromRightP:nth-child(2) .fromRight {\n    animation-delay: 0.35s;\n  }\n\n  .fromRightP:nth-child(3) .fromRight {\n    animation-delay: 0.5s;\n  }\n\n  .fromRightP:nth-child(4) .fromRight {\n    animation-delay: 0.65s;\n  }\n\n  .fromRightP:nth-child(5) .fromRight {\n    animation-delay: 0.8s;\n  }\n\n  .fromRightP:nth-child(6) .fromRight {\n    animation-delay: 0.95s;\n  }\n\n  .scaleUp {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 36px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 6.5vh;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 17px;\n  margin-top: 5vh;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    m: "auto",
    as: "section"
}).withConfig({
    componentId: "sc-896b5acc-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeIn */ .Ji, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fromRight */ .hb, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInRight */ .ER, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInTop */ .E_, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInDown */ .d7, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .scaleUp */ .wK);
var SectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "h1",
    family: "bold",
    height: 1,
    m: "0px"
}).withConfig({
    componentId: "sc-896b5acc-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);
var SectionSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    family: "light",
    height: 1.5
}).withConfig({
    componentId: "sc-896b5acc-2"
})(_templateObject2(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);



/***/ })

}]);